{
  "jira-work-item-view-native-projects-field.body": [
    {
      "type": 0,
      "value": "Your existing project connections have moved to the new field. Nothing to set up."
    }
  ],
  "jira-work-item-view-native-projects-field.button.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-work-item-view-native-projects-field.button.done": [
    {
      "type": 0,
      "value": "Got it"
    }
  ],
  "jira-work-item-view-native-projects-field.headline": [
    {
      "type": 0,
      "value": "Projects are now part of Jira"
    }
  ],
  "jira-work-item-view-native-projects-field.image-alt": [
    {
      "type": 0,
      "value": "Illustration showing a native Atlas project smart card pointing to the project interface"
    }
  ],
  "jira-work-item-view-native-projects-field.tp.body": [
    {
      "type": 0,
      "value": "Connect your work to a project, track progress, and easily share updates."
    }
  ],
  "jira-work-item-view-native-projects-field.tp.button.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-work-item-view-native-projects-field.tp.button.done": [
    {
      "type": 0,
      "value": "Try Projects"
    }
  ],
  "jira-work-item-view-native-projects-field.tp.headline": [
    {
      "type": 0,
      "value": "Share updates with Projects"
    }
  ],
  "jira-work-item-view-native-projects-field.tp.image-alt": [
    {
      "type": 0,
      "value": "Illustration showing the new Projects field in the Jira work item view, ready to connect work to a project"
    }
  ]
}